import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as pullRequests from '../../../../pull-requests'
import * as requirement from '../requirement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: requirement.RESOURCE.payload.dimension.partialId,
      partialId: requirement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The approval pull request that last changed the technical requirement file.',
    isOptional: true,
    name: 'Technical Requirement Pull Request',
    partialId: PartialId.Standard.create('tech_req_pull_request'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        pullRequests.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
